<template>
  <div class="sufee-login d-flex align-content-center flex-wrap">
    <div class="container">
      <div class="login-content">
        <!--<div class="login-logo">-->
        <!--<a href="index.html">-->
        <!--<img class="align-content" src="assets/logo.png" alt="">-->
        <!--</a>-->
        <!--</div>-->
        <div class="login-form">
          <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
          <!--<form>-->
          <div class="form-group">
            <label>{{$t('login.language')}}</label>
            <LngChooser/>
          </div>
          <h4 class="h4title">{{$t('remember.title')}}</h4>
          <!--<div class="form-group">-->
            <!--<label>{{$t('register.firstName')}}</label>-->
            <!--<input @keyup="keymonitorNext" v-model="data.firstName" type="firstName" class="form-control" placeholder="" value=""  v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.name')}">-->
          <!--</div>-->
          <!--<div class="form-group">-->
            <!--<label>{{$t('register.lastName')}}</label>-->
            <!--<input @keyup="keymonitorNext" v-model="data.lastName" type="lastName" class="form-control" placeholder="" value=""  v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.name')}">-->
          <!--</div>-->
          <!--<div class="form-group">-->
            <!--<label>{{$t('register.role')}}</label>-->
              <!--<select id="type" class="form-control" v-model="data.role" name="data.role" v-validate="'required'" v-bind:class="{'is-invalid': errors.has('data.role')}">-->
                <!--<option value="">{{$t('form.pleasechoose')}}</option>-->
                <!--<option value="ADMIN">{{$t('register.roles.ADMIN')}}</option>-->
                <!--<option value="USER">{{$t('register.roles.USER')}}</option>-->
              <!--</select>-->
          <!--</div>-->
          <!--<div class="form-group">-->
          <!--<label>{{$t('register.username')}}</label>-->
          <!--<input @keyup="keymonitorNext" v-model="data.username" type="username" class="form-control" placeholder="" value="">-->
          <!--</div>-->
          <div class="form-group">
            <label>{{$t('register.email')}}</label>
            <input @keyup="keymonitor" v-model="data.email" type="email" class="form-control" placeholder="" value=""  v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.name')}">
          </div>
          <!--<div class="form-group">-->
          <!--<label>{{$t('register.avatar')}}</label>-->
          <!--<input @keyup="keymonitorNext" v-model="data.avatar" type="avatar" class="form-control" placeholder="" value="">-->
          <!--</div>-->
          <!--<div class="form-group">-->
            <!--<label>{{$t('register.phone')}}</label>-->
            <!--<input @keyup="keymonitorNext" v-model="data.phone" type="phone" class="form-control" placeholder="" value=""  v-validate="'required'" v-bind:class="{'is-invalid':errors.has('data.name')}">-->
          <!--</div>-->


          <!--<div class="form-group">-->
          <!--<label>{{$t('register.password')}}</label>-->
          <!--<input @keyup="keymonitor" v-model="data.password" type="password" class="form-control" placeholder="" value="">-->
          <!--</div>-->

          <!--<div class="row form-group">-->
            <!--<div class="col "><label for="password" class=" form-control-label">{{ $t('myuser.password') }} </label></div>-->
            <!--<div class="col-12 ">-->
              <!--<input v-model="data.password" type="password" id="password" placeholder="" class="form-control" name="data.password"-->
                     <!--v-validate="'required|userPassEqualMin8'" v-bind:class="{'is-invalid':errors.has('data.password')}" v-on:keyup="doValidateOnBlur">-->
            <!--</div>-->
            <!--<br><br>-->
            <!--<div class="col "><label for="password2" class=" form-control-label">{{ $t('myuser.password2') }} </label></div>-->
            <!--<div class="col-12 ">-->
              <!--<input v-model="data.password2" type="password" id="password2" placeholder="" class="form-control" name="data.password2"-->
                     <!--v-validate="'required|userPassEqualMin8'"-->
                     <!--v-bind:class="{'is-invalid': errors.has('data.password2')}" v-on:keyup="doValidateOnBlur">-->
              <!--&lt;!&ndash;v-validate="{is_not:!data.password,'required_if':({data.password}.length>0)}" v-bind:class="{'is-invalid': errors.has('data.password2')}">&ndash;&gt;-->
              <!--<small class="form-text text-muted">{{ $t('myuser.passwordhint') }}</small>-->
            <!--</div>-->
          <!--</div>-->

          <div class="checkbox">
            <!--<label>-->
            <!--<input type="checkbox"> Remember Me-->
            <!--</label>-->
            <label class="pull-right">
              <!--<router-link to="/forgottenpassword" tag="a" class="">{{$t('register.forgottenpassword')}}</router-link>-->
            </label>

          </div>
          <button v-on:click="remember()" class="btn-register btn btn-success btn-flat m-b-30 m-t-30">{{$t('register.submit')}}</button>
          <!--<div class="social-register-content">-->
            <!--<div class="social-button">-->
              <!---->
              <!--<button type="button" class="btn social facebook btn-flat btn-addon mb-3"><i class="ti-facebook"></i>Sign in with facebook</button>-->
              <!--<button type="button" class="btn social twitter btn-flat btn-addon mt-2"><i class="ti-twitter"></i>Sign in with twitter</button>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="register-link m-t-15 text-center">-->
            <!--<p>Don't have account ? <a href="#"> Sign Up Here</a></p>-->
          <!--</div>-->
          <!--</form>-->

          <br>
          <br>
          <div class="register-link m-t-15 text-center">
            <p>{{$t('register.doyouhaveanaccount')}} <router-link :to="{ path: '/login'}"> {{$t('register.login')}}</router-link></p>
          </div>

        </div>
      </div>
    </div>
  </div>


</template>


<script>
  import Api from '@/api/Api';
  import LngChooser from '@/components/LngChooser.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Helper from '@/helper/Helper';

  export default {
    name: 'Remember',
    data() {
      return {
        data: {
//          password: "",
//          password2: "",
////          role: "USER",
//          firstName: "",
//          lastName: "",
//          username: "",
          email: "",
//          avatar: "",
//          phone: ""
        }
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          msgPre: "",
          msgPost: "",
          delay: 5000,
        }

      };
    },
    mounted() {
      const modul = this;
      this.$store.state.user = [];
      Api.logout({}).then(function (e) {
        if (e && e.result === true) {
          // logged out
        }
      });
//      modul.$validator.extend('userPassEqualMin8', (val) => {
//        return ((modul.data.password === "" && modul.data.password2 === "") || (modul.data.password.length >= 8 && modul.data.password === modul.data.password2));
//      });
    },
    methods: {
//      keymonitorNext(event){
//        const modul = this;
////        if (event.key === "Enter") {
////          document.querySelector('[type="password"]').focus();
////        }
//      },
      keymonitor(event){
        const modul = this;
        if (event.key === "Enter") {
          modul.remember();
        }
      },
      doValidateOnBlur(){
        const modul = this;
        modul.$validator.validateAll().then((result) => {
        });
      },
      remember(){
        const modul = this;
        console.log("remember")
        modul.$validator.validateAll().then((result) => {
          if (result) {
            const data = Helper.makeFilteredObjectByKeys(modul.data, [ "email"]); // ,"avatar"
            modul.AlertInPage.msg = "form.in_progress";
            modul.AlertInPage.type = "warning";
            Api.remember({data:data}).then(function (e) {
              if (e && e.result === true && e.data === true) {

//                if (e && e.token) {
//                  localStorage.token = e.token;
//                }
//                if (e && e.moduleRights) {
//                  modul.$store.state.moduleRights = e.moduleRights;
//                }

                modul.$store.state.user = e.user;
                modul.AlertInPage.msg = "remember.textsucces";
                modul.AlertInPage.type = "success";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                  // Redirect
                  console.log("redirect login from Remember")
                  modul.$router.push({name: "login"})
                }, Number(1000));
              } else {
                modul.AlertInPage.msg = "remember.texterror";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(5000));
              }
            }, function (e) {
              modul.AlertInPage.msg = "form.error";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(modul.AlertInPage.delay));
            });

          } else {
            modul.AlertInPage.msg = "form.save_error";
            modul.AlertInPage.type = "danger";
          }
        });
      }
    },
    components: {
      LngChooser
      , AlertInPage
    },
  };
</script>

<style scoped>
  .h4title{
    margin-bottom:10px;
  }
</style>
